import { render } from "./VISFormModal.vue?vue&type=template&id=24eb1b48&scoped=true"
import script from "./VISFormModal.vue?vue&type=script&lang=js"
export * from "./VISFormModal.vue?vue&type=script&lang=js"

import "./VISFormModal.vue?vue&type=style&index=0&id=24eb1b48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24eb1b48"]])

export default __exports__